import ToastUtils from '../utils/toast';
import {getAuthHeaders} from './auth.sso';
import {handleHttpError, handleNetworkError} from './errorHandler';

const API_BASE_URL = '/panel/v1';
const API_SSO_URL = '/sso/v1';

/**
 * Универсальный метод для выполнения API-запросов
 * @param {string} endpoint - путь после /panel/ или /sso/ (например, 'users', 'users/1')
 * @param {string} method - HTTP метод (GET, POST, PUT, DELETE)
 * @param {object} data - Данные для отправки в теле запроса (опционально)
 * @param {boolean} isFile - Флаг, указывающий, что ожидается бинарный файл (например, PDF)
 * @param {string} apiUrl - URL API ('base' или 'sso'). По умолчанию 'base' (API_BASE_URL)
 * @returns {Promise} - Промис с данными ответа или объектом Response для файлов
 */
export const apiRequest = async (endpoint, method = 'GET', data = null, isFile = false, apiUrl = 'base') => {
  try {
    const apiUrlValue = apiUrl === 'sso' ? API_SSO_URL : API_BASE_URL;
    const url = `${apiUrlValue}/${endpoint}`;
    
    // Получаем актуальные заголовки авторизации (с автоматическим обновлением токена)
    const headers = await getAuthHeaders();
    
    // Проверяем, авторизован ли пользователь
    if (!headers['Authorization']) {
      throw new Error('Пользователь не авторизован');
    }
    
    // Определяем заголовки в зависимости от типа данных
    const isFormData = data instanceof FormData;
    
    const config = {
      method,
      headers: {
        ...headers
      },
    };
    
    // Для FormData не устанавливаем Content-Type, браузер сделает это автоматически
    if (!isFormData) {
      config.headers['Content-Type'] = 'application/json';
    } else {
      // Для FormData удаляем Content-Type, чтобы браузер мог установить его автоматически с правильным boundary
      delete config.headers['Content-Type'];
    }
    
    // Добавляем тело запроса для методов POST и PUT
    if (data && (method === 'POST' || method === 'PUT' || method === 'PATCH' )) {
      config.body = isFormData ? data : JSON.stringify(data);
    }
    
    const response = await fetch(url, config);

    // Если ожидаем файл, возвращаем объект Response для дальнейшей обработки
    if (isFile) {
      if (!response.ok) {
        const errorText = await response.text();
        handleHttpError(response.status, errorText);
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response; // Возвращаем объект Response
    }

    // Пытаемся распарсить JSON ответ (для обычных запросов)
    let responseData = {};
    try {
      const text = await response.text();
      try {
        responseData = JSON.parse(text);
      } catch (jsonError) {
        // Если не JSON, используем текст как сообщение
        responseData.message = text;
      }
    } catch (e) {
      // Если не удалось прочитать текст
      responseData.message = 'Не удалось получить ответ от сервера';
    }

    // Обрабатываем успешный ответ
    if (response.ok) {
      // if (responseData.message) {
      //   ToastUtils.success(responseData.message);
      // }
      return responseData;
    }
    // Обрабатываем ошибки
    else {
      handleHttpError(response.status, responseData);
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
  } catch (error) {
    // Обрабатываем сетевые ошибки и другие исключения
    handleNetworkError(error);
    throw error;
  }
};